import { createSeenState } from './createSeenState';
import { DISMISS_STATE_KIND } from './DISMISS_STATE_KIND';
import type { DismissStateTransition } from './DismissStateTransition';
import { getLocalState } from './getLocalState';
import { setLocalState } from './setLocalState';

export const recordFirstView = async (aaid: string): Promise<DismissStateTransition> => {
	const state = getLocalState(aaid);
	if (state !== null) {
		// We only stamp "first seen" once, so repeated calls do not overwrite the original time.
		return { from: state.kind, to: state.kind, noop: true };
	}

	await setLocalState(aaid, createSeenState(Date.now()));
	return { from: null, to: DISMISS_STATE_KIND.SEEN, noop: false };
};
